import React from 'react';
import { Box, ThemeProvider, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { theme } from '../../style/theme';
import { PasswordForm } from './PasswordForm';
import { motion } from 'framer-motion';
import datavLogo from '../../Images/datav_logo.png';
import { PrimaryFooter } from '../../components/ui/footer';

export function PasswordPage() {
  const navigate = useNavigate();

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: '100vh',
          width: '100%',
          maxWidth: '100vw',
          display: 'flex',
          flexDirection: 'column',
          background: '#e8fafc',
          position: 'relative',
          overflowX: 'hidden',
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            width: '100%',
            p: { xs: 1.5, sm: 2, md: 3 },
            py: { xs: 1, sm: 1, md: 1 },
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
          }}
        >
          <Box
            component="img"
            src={datavLogo}
            alt="Dataverse"
            onClick={() => navigate('/')}
            sx={{
              cursor: 'pointer',
              height: 'auto',
              maxWidth: { xs: '90px', sm: '115px', md: '135px' },
              width: { xs: '54px', sm: '72px', md: '85px' },
              objectFit: 'contain',
              display: 'block',
              imageRendering: '-webkit-optimize-contrast',
              WebkitImageRendering: 'crisp-edges',
              msImageRendering: 'crisp-edges',
              backfaceVisibility: 'hidden',
              transform: 'translateZ(0)',
              WebkitFontSmoothing: 'antialiased',
              MozOsxFontSmoothing: 'grayscale',
              '&:hover': {
                opacity: 0.8,
              },
              transition: 'opacity 0.2s ease',
            }}
          />
        </Box>

        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: { xs: 1.5, sm: 2, md: 3 },
            pb: { xs: 3, sm: 4, md: 4 },
            overflowX: 'hidden',
            boxSizing: 'border-box',
            width: '100%',
            maxWidth: '100%',
          }}
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
            style={{ width: '100%', maxWidth: '556px', boxSizing: 'border-box' }}
          >
            <Paper
              elevation={0}
              sx={{
                width: '100%',
                maxWidth: '100%',
                p: { xs: 2, sm: 2.5, md: 3 },
                background: '#FFFFFF',
                borderRadius: '8px',
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
                boxSizing: 'border-box',
                overflow: 'hidden',
              }}
            >
              <PasswordForm />
            </Paper>
          </motion.div>
        </Box>
        <PrimaryFooter />
      </Box>
    </ThemeProvider>
  );
}

export default PasswordPage;
